package com.yet.tetris.domain.model.game

enum class TetrominoType {
    I,
    O,
    T,
    S,
    Z,
    J,
    L,
}
